export const TEST_ID = 'equipmentIcon';
